import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 18.558V5.442l5-1.667v16.45l-5-1.667zM11 21v.613a1 1 0 01-1.316.948l-7-2.333A1 1 0 012 19.279V4.721a1 1 0 01.684-.949l7-2.333A1 1 0 0111 2.387V3h3a2 2 0 012 2v3a1 1 0 11-2 0V5h-3v14h3v-2.5a1 1 0 112 0V19a2 2 0 01-2 2h-3zm7.71-12.7l3 3a1 1 0 010 1.4l-3 3c-.95.95-2.36-.46-1.42-1.4l1.3-1.3H14a1 1 0 110-2h4.59l-1.3-1.3c-.94-.94.47-2.35 1.42-1.4z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
